<template>
  <UnSwitcherNew
    swKey="sw_actions_grouping"
    tstPrefix="actions_grouping"
    :hasOpener="false"
  >
    <template #menu_after>
      <div class="bt-grey my-1"></div>
      <div
        class="gw_btn no-events gw_btn_text gw_btn_small clr-grey text-medium f-justify-start bt-grey"
        style="--padding: 0.375rem"
      >
        <span class="keyboardkey_key">
          {{ $store.getters.hotkeys.switch_actions_grouping.displayCombination }}
        </span>
        <span
          class="keyboardkey_note"
          v-html="$t('hotkeys.study.to_toggle_grouping')"
        ></span>
      </div>
    </template>
  </UnSwitcherNew>
</template>

<script>
import UnSwitcherNew from '@/components/Switchers/UnSwitcher_new'

export default {
  name: 'StudyGroupingSwitcher',
  components: {
    UnSwitcherNew,
  },
}
</script>
